import {Component, Inject, OnInit} from '@angular/core';
import {Partner} from '../../../shared/interface/partner';
import {PartnerFacility} from '../../../shared/interface/partner-facility';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface OfwcaAddDialogData {
  partner?: Partner;
  facility?: PartnerFacility;
}

@Component({
  selector: 'app-ofwca-add-dialog',
  templateUrl: './ofwca-add-dialog.component.html',
  styleUrls: ['./ofwca-add-dialog.component.scss']
})
export class OfwcaAddDialogComponent implements OnInit {
  partnerObject?: Partner = null;
  facilityObject?: PartnerFacility = null;

  constructor(
    public dialogRef: MatDialogRef<OfwcaAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OfwcaAddDialogData
  ) {
    this.partnerObject = data.partner;
    this.facilityObject = data.facility;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
